import type { FC } from 'react';
import { lazy } from 'react';

const Routes = lazy(() => import('./routes'));

export const ModulationServiceAuctions: FC = () => {
  return <Routes />;
};
